import initCore from '@easyapp/core';
import initReact from '@easyapp/react';
import initWechat from '@easyapp/wechat';
import {
  app,
  rootReducer,
  rootSaga,
  httpFetch,
  // initTrack,
  initKefu,
} from 'cbmms-js/web';
import * as router from './router';
import cbmmsWechatOptions from './cbmmsWechatOptions';
import cbmmsSyncAuth from './cbmmsSyncAuth';
import keepfitWechatOptions from './keepfitWechatOptions';
import keepfitSyncAuth from './keepfitSyncAuth';

const env = {
  debug: process.env.REACT_APP_DEBUG === '1',
  origin: process.env.REACT_APP_ORIGIN,
  gioId: process.env.REACT_APP_GIO_ID,
};

const coreOptions = {
  store: { rootReducer, rootSaga, debug: env.debug },
  fetchAPI: {
    origin: process.env.NODE_ENV == 'development' ? '' : env.origin,
    parseData: json => {
      const { code, message, now, obj } = json;

      if (code < 0) {
        const error = new Error(message);
        error.code = code;

        throw error;
      }

      return { data: obj, now };
    },
  },
};
const wechatOptions = {
  fetchTicket: url =>
    app
      .fetchAPI({ url: '/api/weixin/jsapi/ticket', data: { url } })
      .then(result => result.data),

  getAuthURL: loc => {
    const state = app.store.getState();
    const shareUid = state.own.shareUid;

    return app.stringifyLocation({
      pathname: env.origin + '/api/login',
      searchData: { shareUid, redirectUrl: loc },
    });
  },
  fetchPayCode: ({ payModule, id }) => {
    let url = '';

    if (payModule === 1) {
      url = `/api/order/${id}/wx/paycode`;
    } else if (payModule === 2) {
      url = `/api/after/${id}/payCode`;
    } else if (payModule === 3) {
      url = `/efapi/order/${id}/wxpay`;
    }
    return app.fetchAPI({ url }).then(result => result.data.wxPayInfo);
  },

  jsApiList: [
    'onMenuShareAppMessage',
    'onMenuShareTimeline',
    'onMenuShareQQ',
    'onMenuShareQZone',
    'onMenuShareWeibo',
    'hideMenuItems',
    'chooseWXPay',
    'previewImage',
    'getLocation',
    'openLocation',
  ],

  hiddenMenuList: [
    // 'menuItem:copyUrl',
    'menuItem:share:email',
    'menuItem:share:brand',
    'menuItem:share:timeline',
  ],
};

export default function initApp(options) {
  Object.assign(app, initCore(coreOptions));
  Object.assign(app, initReact(app));

  return Promise.resolve()
    .then(() => {
      const ua = navigator.userAgent.toLowerCase();
      const location = app.parseLocation(app.getTopPage());
      const { 'CB-WXS': cbWxs } = location.searchData;
      if (ua.indexOf('micromessenger') !== -1 && ua.indexOf('wxwork') === -1) {
        if (cbWxs === 'keepfit') {
          Object.assign(wechatOptions, keepfitWechatOptions);
        } else {
          Object.assign(wechatOptions, cbmmsWechatOptions);
        }

        return initWechat(app, wechatOptions).then(apis => {
          Object.assign(app, apis);

          if (app.weapp) {
            if (cbWxs === 'keepfit') {
              app.weapp.syncAuth = keepfitSyncAuth;
            } else {
              app.weapp.syncAuth = cbmmsSyncAuth;
            }
          }
        });
      }
    })
    .then(() =>
      Object.assign(
        app,
        options,
        router,
        { httpFetch, env },
        // initTrack(),
        initKefu()
      )
    )
    .then(() => {
      app.store.runSaga();
    });
}
